module.exports = __webpack_public_path__ + "static/media/Gilroy-Medium.c83281ae.ttf";